/**
 * Portfolio projects — card data (PortfolioSection) + detail page content.
 */

export const PORTFOLIO_PROJECTS = [
  {
    slug: "brand-web",
    path: "/portfolio/brand-web",
    demoPath: "/portfolio/brand-web/demo",
    tag: "BRAND WEB",
    title: "홈페이지 제작",
    url: "dsitesolution.com",
    heroColor: "linear-gradient(135deg,#e8f4f8,#d4e8f0)",
    accent: "#1e3a5f",
    cardImage: "/portfolio/corporate/kakao-bank.webp",
    categoryTags: ["맞춤형 제작", "반응형", "3D·인터랙션"],
    shortDescription:
      "병원, 기업·금융, 카페, F&B, 교육, 커머스, 부동산, 미용·헬스, SaaS 등 다양한 업종의 홈페이지 제작 사례. 3D·인터랙션과 반응형 퍼블리싱까지 포함한 맞춤형 웹 제작 포트폴리오입니다.",
    overview:
      "DSiteSolution의 홈페이지 제작 역량을 보여주는 포트폴리오입니다. 업종과 브랜드 성격에 따라 정보 구조, 디자인 톤, 섹션 구성을 달리 적용했으며, 3D 메뉴·매장 뷰어 등 인터랙션 요소로 몰입감 있는 경험까지 설계한 제작 사례를 확인할 수 있습니다.",
    problem:
      "업종마다 필요한 정보 구조와 신뢰감을 주는 디자인 톤이 다릅니다. 범용 템플릿만으로는 브랜드 개성이 드러나지 않고, 정적인 화면 구성만으로는 브랜드·메뉴·공간의 매력을 충분히 전달하기 어렵습니다. 예약·문의·서비스 안내 등 핵심 정보가 부족하면 실제 운영 사이트로서 설득력도 떨어집니다.",
    solution:
      "고객사의 업종·브랜드·운영 목적에 맞춰 홈페이지를 기획·디자인·퍼블리싱합니다. 필요에 따라 3D 메뉴 체험, 매장·공간 3D 뷰어, 스크롤·모션 인터랙션을 적용해 브랜드 경험을 한층 강화합니다. 포트폴리오에서는 서로 다른 성격의 제작 사례를 나란히 비교하며, DSiteSolution이 어떤 방식으로 맞춤 제작하는지 보여줍니다.",
    keyFeatures: [
      "업종·브랜드 특성에 맞춘 맞춤형 홈페이지 기획·제작",
      "병원, 기업·금융, 카페, F&B, 교육, 커머스, 부동산, 미용·헬스, SaaS 등 다양한 분야 제작 경험",
      "3D 메뉴·매장 뷰어, 스크롤·모션 등 인터랙션·3D UI 적용",
      "브랜드 아이덴티티에 맞는 컬러·타이포·레이아웃 설계",
      "예약, 문의, 서비스 안내 등 실제 운영에 필요한 화면 구성",
      "모바일·태블릿·데스크톱 반응형 퍼블리싱",
      "고객사 목적에 따라 유연하게 확장·변형 가능한 구조",
    ],
    uiConcept:
      "정해진 틀에 맞추기보다, 각 브랜드의 신뢰감과 분위기에 맞는 디자인을 설계합니다. 의료·기업·금융·F&B 등 업종별로 필요한 인상과 정보 우선순위가 다르기 때문에, 컬러·타이포·섹션 구성을 매번 새롭게 맞춥니다. F&B·리테일 등에서는 3D로 메뉴와 공간을 직접 체험하게 하고, 기업·SaaS에서는 스크롤·모션으로 서비스 가치를 전달합니다.",
    expectedResult:
      "방문자가 다양한 업종의 제작 결과물과 3D·인터랙션 적용 사례를 통해 DSiteSolution의 기획·디자인·퍼블리싱 역량을 직관적으로 이해할 수 있습니다. 새로운 업종·브랜드 상담 시에도 맞춤 제작과 3D·인터랙션 확장이 가능하다는 신뢰를 전달합니다.",
  },
  {
    slug: "ai-code-review",
    path: "/portfolio/ai-code-review",
    demoPath: "/portfolio/ai-code-review/demo",
    tag: "AI PLATFORM",
    title: "AI 코드 리뷰 시스템",
    url: "dsitesolution.com/ai",
    heroColor: "linear-gradient(135deg,#031030,#1a3a7a)",
    accent: "#4a8fff",
    cardImage: "/portfolio/corporate/toss-bank.webp",
    categoryTags: ["AI 교육", "코드 리뷰", "학습 플랫폼"],
    shortDescription:
      "학습자가 코드를 제출하면 AI가 분석·피드백을 제공하고, 강사는 한 화면에서 진도와 품질을 관리하는 교육용 플랫폼입니다.",
    overview:
      "교육기관과 개발 학습자를 위한 AI 기반 코드 리뷰 시스템입니다. 코드 제출부터 자동 분석, 개선 제안, 강사 피드백까지 한 흐름으로 연결해 학습 효율을 높입니다.",
    problem:
      "강사가 모든 제출 코드를 직접 검토하기 어렵고, 학습자는 피드백을 늦게 받아 같은 실수를 반복합니다. 과제 관리와 품질 추적이 분산되어 운영 부담이 큽니다.",
    solution:
      "AI가 코드 품질·구조·개선 포인트를 먼저 분석하고, 강사는 핵심 피드백에 집중할 수 있도록 대시보드를 제공합니다. 제출 이력과 점수 추이를 한곳에서 확인할 수 있습니다.",
    keyFeatures: [
      "코드 제출 및 언어별 AI 분석",
      "개선 제안·오류 패턴 자동 리포트",
      "강사용 클래스·학생 관리",
      "피드백 히스토리 및 학습 추이",
      "과제 마감·알림 자동화",
      "권한별 접근(학생/강사/관리자)",
    ],
    uiConcept:
      "코드 에디터와 리뷰 패널을 나란히 배치해 ‘제출 → 분석 → 피드백’ 흐름이 한눈에 보이도록 설계합니다. 블루 네온 라인으로 AI 분석 구간을 강조합니다.",
    expectedResult:
      "강사의 검토 시간을 줄이고, 학습자는 더 빠른 피드백으로 실력을 개선할 수 있습니다. 교육기관은 클래스별 품질 지표를 데이터로 관리할 수 있습니다.",
  },
  {
    slug: "edtech",
    path: "/portfolio/edtech",
    demoPath: "/portfolio/edtech/demo",
    tag: "EDTECH",
    title: "교육 운영 시스템",
    url: "dsitesolution.com/edtech",
    heroColor: "linear-gradient(135deg,#071a07,#1a5c20)",
    accent: "#34c472",
    categoryTags: ["학원 운영", "강의 관리", "수강생 관리"],
    shortDescription:
      "강의·수강생·과제·피드백을 하나의 플랫폼에서 운영해 학원과 교육 사업자의 반복 업무를 줄입니다.",
    overview:
      "학원, 온라인 강의, 클래스 기반 교육 사업을 위한 통합 운영 플랫폼입니다. 강의 개설부터 수강생 관리, 과제 제출, 피드백, 알림까지 일상 운영을 디지털화합니다.",
    problem:
      "강의 일정, 수강생 정보, 과제·피드백이 엑셀·메신저·이메일로 흩어져 있어 누락과 중복 안내가 발생합니다. 운영 인력이 늘어나도 확장이 어렵습니다.",
    solution:
      "강의·클래스·수강생을 중심으로 운영 흐름을 통합하고, 과제 제출과 피드백을 시스템 안에서 처리합니다. 자동 알림과 상태 대시보드로 운영자가 현황을 즉시 파악합니다.",
    keyFeatures: [
      "강의·클래스·커리큘럼 관리",
      "수강생 등록 및 출결·진도 추적",
      "과제 제출·채점·피드백 워크플로",
      "학부모·수강생 알림(이메일/카카오 연동 가능)",
      "강사별 권한 및 클래스 분리",
      "운영 현황 요약 대시보드",
    ],
    uiConcept:
      "카드형 클래스 목록과 타임라인형 일정 UI로 ‘오늘 해야 할 일’이 바로 보이게 구성합니다. 그린 포인트 컬러로 성장·학습 이미지를 강조합니다.",
    expectedResult:
      "운영자는 한 화면에서 수강생 상태를 확인하고, 수강생은 제출·피드백을 명확히 받을 수 있습니다. 반복 안내 업무가 줄어 운영 효율이 개선됩니다.",
  },
  {
    slug: "brand-storytelling",
    path: "/portfolio/brand-storytelling",
    demoPath: "/portfolio/brand-storytelling/demo",
    tag: "BRAND STORYTELLING",
    title: "브랜드 홈페이지",
    url: "dsitesolution.com/story",
    heroColor: "linear-gradient(135deg,#1e1040,#3a1f6e)",
    accent: "#9b6aff",
    categoryTags: ["브랜드 스토리", "회사 소개", "신뢰 구축"],
    shortDescription:
      "회사 철학과 서비스 가치를 스토리로 전달해, 방문자가 브랜드를 기억하고 신뢰할 수 있는 소개형 웹사이트입니다.",
    overview:
      "회사 소개·브랜드 철학·서비스·팀·고객 사례를 스토리텔링 구조로 배치한 브랜드 홈페이지입니다. 첫 방문자도 ‘이 회사가 왜 믿을 만한지’ 빠르게 이해하도록 설계합니다.",
    problem:
      "회사 소개 페이지가 정보만 나열하면 차별점이 전달되지 않고, 방문자가 기억에 남지 않습니다. B2B 고객은 신뢰 근거 없이는 다음 단계로 넘어가지 않습니다.",
    solution:
      "브랜드 미션 → 문제 인식 → 해결 방식 → 서비스 → 실적 순으로 스토리를 구성하고, 시각적 일관성으로 전문성을 강화합니다. 문의·미팅 요청으로 자연스럽게 연결합니다.",
    keyFeatures: [
      "브랜드 스토리·미션·비전 섹션",
      "서비스·차별점 카드형 소개",
      "실적·고객 신뢰 지표 노출",
      "팀·프로세스 소개 레이아웃",
      "반응형 스크롤 스토리텔링",
      "문의·상담 CTA 최적 배치",
    ],
    uiConcept:
      "풀블리드 비주얼과 글래스 패널을 교차 배치해 몰입감 있는 스크롤 경험을 만듭니다. 퍼플 네온 라인으로 브랜드 하이라이트 구간을 구분합니다.",
    expectedResult:
      "방문자가 회사의 방향성과 강점을 짧은 시간 안에 이해하고, 파트너·고객 문의로 이어질 확률이 높아집니다. 브랜드 신뢰도와 인지도 강화에 기여합니다.",
  },
  {
    slug: "admin-page",
    path: "/portfolio/admin-page",
    demoPath: "/portfolio/admin-page/demo",
    tag: "INTERNAL TOOLS",
    title: "관리자 페이지",
    url: "dsitesolution.com/admin",
    heroColor: "linear-gradient(135deg,#0f2030,#1a4050)",
    accent: "#3ab4cc",
    categoryTags: ["관리자", "운영 도구", "권한 관리"],
    shortDescription:
      "내부 운영자가 회원·콘텐츠·문의·권한을 한곳에서 관리하는 관리자 시스템으로, 서비스 운영을 안정적으로 뒷받침합니다.",
    overview:
      "서비스 운영팀을 위한 관리자 대시보드입니다. 회원 관리, 콘텐츠 수정, 문의 처리, 권한 설정, 데이터 조회를 웹 브라우저에서 바로 처리할 수 있습니다.",
    problem:
      "운영 업무가 여러 도구와 수동 작업에 의존하면 처리 지연이 생기고, 권한 관리가 느슨해 보안·실수 리스크가 커집니다. 현황 파악에도 시간이 많이 듭니다.",
    solution:
      "역할 기반 권한과 통합 관리 화면을 제공해, 운영자가 필요한 작업만 빠르게 수행합니다. 문의·회원·콘텐츠 상태를 필터·검색으로 즉시 확인합니다.",
    keyFeatures: [
      "회원·계정·권한(Role) 관리",
      "콘텐츠·배너·공지 CMS 연동",
      "문의·상담 티켓 처리 워크플로",
      "활동 로그·감사 추적",
      "검색·필터·페이지네이션",
      "관리자별 접근 범위 제한",
    ],
    uiConcept:
      "사이드바 네비게이션과 데이터 테이블 중심의 실무형 UI입니다. 시안·네온 포인트로 중요 상태(미처리 문의 등)를 즉시 구분합니다.",
    expectedResult:
      "운영팀은 일상 업무를 더 빠르고 정확하게 처리하고, 권한 분리로 보안과 책임 추적이 명확해집니다. 서비스 확장 시에도 운영 체계를 유지할 수 있습니다.",
  },
  {
    slug: "dashboard",
    path: "/portfolio/dashboard",
    demoPath: "/portfolio/dashboard/demo",
    tag: "DATA VIZ",
    title: "대시보드",
    url: "dsitesolution.com/dashboard",
    heroColor: "linear-gradient(135deg,#101828,#1a3050)",
    accent: "#60a5fa",
    categoryTags: ["데이터 시각화", "통계", "운영 분석"],
    shortDescription:
      "매출·유입·사용자 행동·운영 지표를 한 화면에서 확인하는 분석 대시보드로, 의사결정에 필요한 숫자를 바로 파악할 수 있습니다.",
    overview:
      "비즈니스·서비스 운영 데이터를 시각화하는 통계 대시보드입니다. 핵심 KPI, 추이 차트, 세그먼트별 현황을 실시간에 가깝게 확인할 수 있습니다.",
    problem:
      "데이터가 여러 시트와 보고서에 흩어져 있으면 의사결정이 늦어지고, 팀마다 다른 숫자를 기준으로 이야기하게 됩니다. 운영 이슈를 늦게 발견합니다.",
    solution:
      "핵심 지표를 카드와 차트로 통합하고, 기간·채널·사용자군별로 필터링할 수 있게 합니다. 이상 징후가 보이는 구간을 색상·알림으로 강조합니다.",
    keyFeatures: [
      "KPI 카드(매출·유입·전환·이탈)",
      "기간별 추이 차트·비교 뷰",
      "사용자 행동·퍼널 분석",
      "채널·캠페인별 성과 분할",
      "CSV보내기·리포트 공유",
      "역할별 대시보드 뷰 커스터마이즈",
    ],
    uiConcept:
      "다크 배경 위 글래스 KPI 카드와 라인·바 차트를 조합해 ‘한눈에 읽히는’ 레이아웃을 사용합니다. 블루 네온 그리드로 데이터 구간을 시각적으로 연결합니다.",
    expectedResult:
      "경영·운영 담당자가 매일 같은 화면에서 핵심 지표를 확인하고, 문제를 빠르게 발견·대응할 수 있습니다. 데이터 기반 의사결정 속도가 개선됩니다.",
  },
];

/** Card fields used by PortfolioSection scroll animation */
export const PORTFOLIO_CARD_DATA = PORTFOLIO_PROJECTS.map(
  ({ tag, title, url, heroColor, accent, slug, path, demoPath, cardImage }) => ({
    tag,
    title,
    url,
    heroColor,
    accent,
    slug,
    path,
    demoPath,
    /** public/ 기준 경로 — 예: /images/portfolio-cards/brand-web.jpg */
    cardImage: cardImage ?? null,
  }),
);

export function getPortfolioProjectBySlug(slug) {
  return PORTFOLIO_PROJECTS.find((p) => p.slug === slug) ?? null;
}

export function getPortfolioProjectByPath(path) {
  return PORTFOLIO_PROJECTS.find((p) => p.path === path) ?? null;
}
